import type { StateCreator } from 'zustand'
import type { Channel } from '../../types/index.js'

// ─── Slice ────────────────────────────────────────────────────────────────────

export interface ChannelSlice {
  // State
  channels:          Channel[]
  activeChannelId:   string | null
  channelsLoading:   boolean
  channelsError:     string | null

  // Actions
  setChannels:       (channels: Channel[]) => void
  setActiveChannel:  (id: string) => void
  setChannelsLoading:(loading: boolean) => void
  setChannelsError:  (err: string | null) => void
  activeChannel:     () => Channel | null
}

export const createChannelSlice: StateCreator<ChannelSlice, [], [], ChannelSlice> = (set, get) => ({
  channels:          [],
  activeChannelId:   null,
  channelsLoading:   false,
  channelsError:     null,

  setChannels:       (channels) => set({ channels }),
  setActiveChannel:  (id)       => set({ activeChannelId: id }),
  setChannelsLoading:(loading)  => set({ channelsLoading: loading }),
  setChannelsError:  (err)      => set({ channelsError: err }),
  activeChannel:     ()         => get().channels.find(c => c.id === get().activeChannelId) ?? null,
})
